/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1TutoraiConfigMemoryQueryResponse,
  GetApiV1TutoraiConfigMemoryQueryParams,
  GetApiV1TutoraiConfigMemory401,
  GetApiV1TutoraiConfigMemory500,
} from "../../types/tutorAIConfigController/GetApiV1TutoraiConfigMemory.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1TutoraiConfigMemory } from "../../clients/tutorAIConfigController/getApiV1TutoraiConfigMemory.ts";

export const getApiV1TutoraiConfigMemoryQueryKey = (
  params?: GetApiV1TutoraiConfigMemoryQueryParams,
) =>
  [
    { url: "/api/v1/tutorai/config/memory" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1TutoraiConfigMemoryQueryKey = ReturnType<
  typeof getApiV1TutoraiConfigMemoryQueryKey
>;

export function getApiV1TutoraiConfigMemoryQueryOptions(
  params?: GetApiV1TutoraiConfigMemoryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1TutoraiConfigMemoryQueryKey(params);
  return queryOptions<
    GetApiV1TutoraiConfigMemoryQueryResponse,
    ResponseErrorConfig<
      GetApiV1TutoraiConfigMemory401 | GetApiV1TutoraiConfigMemory500
    >,
    GetApiV1TutoraiConfigMemoryQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1TutoraiConfigMemory(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna o contexto injetado nos prompts. Hierarquia de fallback: aluno (`personId` + `classStudentId`) → turma (`classStudentId`) → global. `content` é `null` quando não configurada. **(Requer Authorization para autenticação)**
 * @summary Obter memória do assistente (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/config/memory}
 */
export function useGetApiV1TutoraiConfigMemory<
  TData = GetApiV1TutoraiConfigMemoryQueryResponse,
  TQueryData = GetApiV1TutoraiConfigMemoryQueryResponse,
  TQueryKey extends QueryKey = GetApiV1TutoraiConfigMemoryQueryKey,
>(
  params?: GetApiV1TutoraiConfigMemoryQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1TutoraiConfigMemoryQueryResponse,
        ResponseErrorConfig<
          GetApiV1TutoraiConfigMemory401 | GetApiV1TutoraiConfigMemory500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1TutoraiConfigMemoryQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1TutoraiConfigMemoryQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1TutoraiConfigMemory401 | GetApiV1TutoraiConfigMemory500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
